import { ReactNode } from 'react';

import { useIdentityRef } from '@spotify/plugin-confidence-iam-react';

export interface IdentityResourceLinkProps {
  name: string;
  text: ReactNode;
}

export const IdentityResourceLink = (props: IdentityResourceLinkProps) => {
  const { name, text } = props;
  const { identity } = useIdentityRef({ name });

  return <strong>{identity?.displayName || text}</strong>;
};
